import { useTranslation } from "react-i18next";

import StatusPill, { StatusPillColour } from "../shared/StatusPill";
import { SALES_QUOTE_STATUS_LABELS, SalesQuoteStatus } from "../../models/SalesQuote";

export function SalesQuoteStatusPill({ status }: { status: SalesQuoteStatus }) {
  const { t } = useTranslation("accounts");
  const colour =
    status === SalesQuoteStatus.Open
      ? StatusPillColour.Blue
      : status === SalesQuoteStatus.Converted
        ? StatusPillColour.Green
        : StatusPillColour.Neutral;
  // "quote" context: the Polish status adjectives agree with the (feminine) noun wycena.
  return <StatusPill text={t(SALES_QUOTE_STATUS_LABELS[status] ?? "Unknown", { context: "quote" })} colour={colour} />;
}
